export default {"src":"/_next/static/media/optilyz.09ccf1d6.svg","height":48,"width":160,"blurWidth":0,"blurHeight":0};